exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customPersonDialogBodyClass[data-v-29329279]{opacity:1}.customPersonDialogBodyClass .column[data-v-29329279]{background-repeat:no-repeat;background-size:100%100%;-webkit-background-size:100%100%;-o-background-size:100%100%}.customPersonDialogBodyClass .item[data-v-29329279]{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29329279","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/images/personImages.vue
// module id = 775
// module chunks = 0